import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setCartOpen, setGift } from '../store/cartSlice'
import CartItems from './CartItems.jsx'
import CartBottom from './CartBottom.jsx'
import CartUpsells from './CartUpsells.jsx'
import { updateCart } from '../../utils/Cart.js'
// import { makeLineItem, addLineItems } from "../../utils/Cart.js"

const CartDrawer = (data) => {
  const dispatch = useDispatch()
  const { cart, open, upsells, hasGift } = useSelector((state) => state.cart)
  const drawerContainer = useRef(null)
  const inertedEls = useRef([])
  // const state = {
  //   hasGift: cart.items.filter(item => item.variant_id == data.data.gift_variant_id).length > 0,
  // }

  useEffect(() => {
    // drawerContainer.current.addEventListener('click', (e) => e.stopPropagation())
    drawerContainer.current
      .querySelector('[data-cart-close]')
      .addEventListener('click', (e) => dispatch(setCartOpen(false)))
    const drawer = document.querySelector('[data-cart-drawer]')
    drawer?.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') dispatch(setCartOpen(false))
    })
    drawer?.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return
      const focusables = drawerContainer.current.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      )
      if (focusables.length === 0) return
      const first = focusables[0]
      const last = focusables[focusables.length - 1]
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    })
  }, [])

  useEffect(() => {
    const drawerWrapper = document.querySelector('[data-cart-drawer]')
    const statusBanner = document.querySelector('[data-cart-add-success]')

    if (open) {
      drawerWrapper?.removeAttribute('inert')
      inertedEls.current = []
      Array.from(document.body.children).forEach((el) => {
        if (el === drawerWrapper || el === statusBanner) return
        if (el.hasAttribute('inert')) return
        el.setAttribute('inert', '')
        inertedEls.current.push(el)
      })
      drawerContainer.current.querySelector('[data-cart-close]').focus()
    } else if (open === false) {
      inertedEls.current.forEach((el) => el.removeAttribute('inert'))
      inertedEls.current = []
      drawerWrapper?.setAttribute('inert', '')
      document.querySelector('[data-cart-open]').focus()
    }

    setTimeout(() => {
      document.body.classList.toggle('overflow-hidden', open)
    }, 200)
  }, [open])

  const drawer = document.querySelector('[data-cart-drawer]')
  drawer.classList.toggle('z-[-1]', !open)
  drawer.classList.toggle('opacity-0', !open)
  drawer.classList.toggle('z-50', open)
  drawer.classList.toggle('opacity-100', open)
  drawer.setAttribute('aria-hidden', !open)
  document.body.classList.toggle('overflow-hidden', open)

  // document.querySelector('[data-cart-drawer]').addEventListener('click', () => dispatch(setCartOpen(false)))

  const toggleGift = (e) => {
    if (hasGift) {
      e.target.disabled = true
      let updates = {}
      updates[data.data.gift_variant_id] = 0
      updateCart(
        () => {
          e.target.disabled = false
          dispatch(setGift(false))
        },
        { updates, note: null },
      )
    } else {
      dispatch(setGift(true))
      // const items = [makeLineItem(data.data.gift_variant_id, 1, [])]
      // addLineItems(() => {
      //   e.target.disabled = false
      // }, items, true)
    }
  }

  return (
    <div
      className={`h-full absolute w-full lg:w-[30.5rem] bg-surface text-second transition duration-300 ease-in-out pl-3 lg:pl-10 pt-6 pb-4 lg:pb-10 ${open ? 'right-0' : 'right-[-31rem]'}`}
      ref={drawerContainer}
      role="dialog"
      aria-labelledby="cartDrawerHeading"
    >
      <div className="flex items-center justify-between pr-3 lg:pr-10">
        <h2 className="text-second" id="cartDrawerHeading">
          Cart&nbsp;&nbsp;
          <sup className="text-second text-[0.625rem]">{cart.item_count}</sup>
        </h2>
        <button
          className="text-second focus-visible:outline focus:outline"
          data-cart-close
          aria-label="Close the cart"
          dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-close'] }}
        />
      </div>
      <div className="h-[calc(100%-1.5rem)] pt-10 text-second flex flex-col justify-between overflow-x-hidden overflow-y-auto">
        {cart.item_count == 0 && (
          <div className="mt-10 text-second text-center w-full pr-3 lg:pr-10">
            You Cart Is Empty.
            <a
              className="mt-6 button w-full !bg-black !text-white !border-black hover:!bg-white hover:!border-black hover:!text-black focus-visible:outline focus:outline"
              href="/"
            >
              Shop Now
            </a>
          </div>
        )}

        {!cart.item_count && (
          <div className="pr-3 lg:pr-10">
            <CartUpsells data={data.data} />
          </div>
        )}

        {cart.item_count > 0 && (
          <div className="cart-drawer--main h-full overflow-auto pr-3 lg:pr-10">
            <CartItems data={data.data} />
            {data.data.enable_gift_messaging && (
              <div className="border-t border-[rgba(33,33,33,0.25)] py-6">
                <label className="cart-checkbox flex gap-4 items-center">
                  <input
                    type="checkbox"
                    name="inline_gift_product"
                    id="inlineGiftProduct"
                    data-inline-gift-product
                    checked={hasGift}
                    onClick={(e) => toggleGift(e)}
                    value={data.data.gift_variant_id}
                  />
                  <div className="uppercase text-sm text-black">Is this a gift?</div>
                </label>
              </div>
            )}

            <CartUpsells data={data.data} />
          </div>
        )}

        {cart.item_count > 0 && <CartBottom data={data.data} />}
      </div>
    </div>
  )
}

export default CartDrawer
